import useGetBankDetailsPageData from "#/components/bank-details/hooks/useGetBankDetailsPage"
import useShowBankDetails from "#/components/bank-details/hooks/useShowBankDetails"
import { PageNotFound } from "#/components/views/error/PageNotFound"
import React from "react"
import { Route } from "react-router"
import CountrySpecificBankDetails from "../../components/bank-details/CountrySpecificBankDetails"
import { IlloUnderwaterPlants } from "#/components/views/atoms/Illustrations"
import EmployeeOnlySpaceContainer from "../../components/employee-only-containers/EmployeeOnlySpaceContainer"
import { FormattedMessage } from "react-intl"
import { PageLayout } from "#/features/global-ui/page-layout"
import { PageHeader, PageHeaderGlyph } from "#/features/global-ui/page-header"
import { Paths } from "#/utils/Paths"
import { Button, Stack, Tile, Typography, useTheme } from "@carrotfertility/carotene-core"

const BankDetailsHeader = (): JSX.Element => (
  <PageHeader
    startGlyph={
      <PageHeaderGlyph src="/images/icn-header-bankdetails.png" srcSet={"/images/icn-header-bankdetails-2x.png"} />
    }
    pageTitle={<FormattedMessage defaultMessage="Bank details" />}
  />
)

const SomethingWentWrong = () => {
  const theme = useTheme()
  return (
    <Tile
      sx={(theme) => ({
        paddingBlockStart: theme.tokens.spacing.lg,
        paddingBlockEnd: theme.tokens.spacing.lg,
        maxInlineSize: "32rem"
      })}
    >
      <Stack
        sx={(theme) => ({
          marginBlockStart: theme.tokens.spacing.xxl,
          marginBlockEnd: theme.tokens.spacing.xxl
        })}
        direction="column"
        alignItems="center"
        justifyContent="center"
        spacing={theme.tokens.spacing.md}
      >
        <IlloUnderwaterPlants />
        <Typography variant="h3" component="h2">
          <FormattedMessage defaultMessage="Something went wrong" />
        </Typography>
        <Button component="a" href={Paths.HOME}>
          <FormattedMessage defaultMessage="Return home" />
        </Button>
      </Stack>
    </Tile>
  )
}

const BankDetailsPage = () => {
  const { showBankDetails } = useShowBankDetails()
  const { data, schema, isError, isLoading } = useGetBankDetailsPageData()

  if (showBankDetails) {
    return (
      <PageLayout header={<BankDetailsHeader />}>
        <EmployeeOnlySpaceContainer>
          {isError ? (
            <SomethingWentWrong />
          ) : (
            <CountrySpecificBankDetails schema={schema} data={data} isLoading={isLoading} />
          )}
        </EmployeeOnlySpaceContainer>
      </PageLayout>
    )
  } else {
    return <Route component={PageNotFound} />
  }
}

export default BankDetailsPage
